module.exports = __webpack_public_path__ + "static/img/pendingBadge.d3384866.png";